import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { format } from "date-fns";

const NotificationDetailsModal = ({
  detailsModal,
  openDetailsModal,
  selectedNotification,
  setSelectedNotification,
}) => {
  const handleCloseDetailsModal = () => {
    setSelectedNotification({});
    openDetailsModal(false);
  };

  return (
    <Modal
      show={detailsModal}
      onHide={handleCloseDetailsModal}
      size="lg"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Notification Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <Row className="mb-3">
          {Object.entries({
            Title: selectedNotification?.title || "",
            Type: selectedNotification?.type || "",
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span className="d-block fs-5 fw-medium">{value}</span>
              </div>
            </Col>
          ))}
          <Col xs={12} md={12} lg={12} className="mb-3">
            <div className="p-3 bg-secondary bg-opacity-10 rounded">
              <span className="text-secondary fs-6 fw-semibold">Message</span>
              <span className="d-block fs-5 fw-medium">
                {selectedNotification?.message || ""}
              </span>
            </div>
          </Col>
          {selectedNotification?.live_id ? (
            <Col xs={12} md={12} lg={12} className="mb-3">
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">Live Id</span>
                <span className="d-block fs-5 fw-medium">
                  {selectedNotification.live_id}
                </span>
              </div>
            </Col>
          ) : selectedNotification?.live_error ? (
            <Col xs={12} md={12} lg={12} className="mb-3">
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">Live Error</span>
                <span className="d-block fs-5 fw-medium">
                  {selectedNotification.live_error}
                </span>
              </div>
            </Col>
          ) : null}
          {Object.entries({
            "Target Type": selectedNotification?.target_type || "",
            Status: selectedNotification?.status || "",
            Priority: selectedNotification?.priority || "",
            Platform: selectedNotification?.platform || "",
            "Created At":
              selectedNotification?.createdAt &&
              format(selectedNotification?.createdAt, "PP"),
            "Updated At":
              selectedNotification?.updatedAt &&
              format(selectedNotification?.updatedAt, "PP"),
          }).map(([key, value]) => (
            <Col xs={12} md={12} lg={6} className="mb-3" key={key}>
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">{key}</span>
                <span className="d-block fs-5 fw-medium">{value}</span>
              </div>
            </Col>
          ))}
          {selectedNotification?.sent_at && (
            <Col xs={12} md={12} lg={6} className="mb-3">
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">Sent At</span>
                <span className="d-block fs-5 fw-medium">
                  {selectedNotification?.sent_at &&
                    format(selectedNotification?.sent_at, "PP")}
                </span>
              </div>
            </Col>
          )}
          {selectedNotification?.notif_created_by && (
            <Col xs={12} md={12} lg={6} className="mb-3">
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">
                  Created By
                </span>
                <span className="d-block fs-5 fw-medium">{`${selectedNotification?.notif_created_by?.first_name || ""} ${selectedNotification?.notif_created_by?.last_name || ""}`}</span>
              </div>
            </Col>
          )}
          {selectedNotification?.notif_updated_by && (
            <Col xs={12} md={12} lg={6} className="mb-3">
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">
                  Updated By
                </span>
                <span className="d-block fs-5 fw-medium">{`${selectedNotification?.notif_updated_by?.first_name || ""} ${selectedNotification?.notif_updated_by?.last_name || ""}`}</span>
              </div>
            </Col>
          )}
          {selectedNotification?.notification_sender && (
            <Col xs={12} md={12} lg={6} className="mb-3">
              <div className="p-3 bg-secondary bg-opacity-10 rounded">
                <span className="text-secondary fs-6 fw-semibold">Sent By</span>
                <span className="d-block fs-5 fw-medium">{`${selectedNotification?.notification_sender?.first_name || ""} ${selectedNotification?.notification_sender?.last_name || ""}`}</span>
              </div>
            </Col>
          )}
        </Row>
      </Modal.Body>
      <Modal.Footer className="bg-dark text-light">
        <Button variant="secondary" onClick={handleCloseDetailsModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default NotificationDetailsModal;
